const BASE_INCLUSIONS = ["Fuel", "Toll Tax", "Driver Perks"];
const CARRIER_VEHICLES = ["SUV", "Innova Crysta"];

export function vehicleInclusions(vehicleName) {
  const list = [...BASE_INCLUSIONS];
  if (CARRIER_VEHICLES.includes(vehicleName)) list.push("Carrier");
  return list;
}

export const VEHICLE_META = {
  "Hatchback": {
    seats: "4+1",
    image: "https://images.unsplash.com/photo-1777998567525-b48a50c54d1c?crop=entropy&cs=srgb&fm=jpg&w=200&q=80",
  },
  "Sedan": {
    seats: "4+1",
    image: "https://images.unsplash.com/photo-1623869675781-80aa31012a5a?crop=entropy&cs=srgb&fm=jpg&w=200&q=80",
  },
  "SUV": {
    seats: "6+1",
    image: "https://images.unsplash.com/photo-1758228674135-ccb8865f1b02?crop=entropy&cs=srgb&fm=jpg&w=200&q=80",
  },
  "Innova Crysta": {
    seats: "6+1",
    image: "https://images.unsplash.com/photo-1748215210939-ad8b6c8c086d?crop=entropy&cs=srgb&fm=jpg&w=200&q=80",
  },
  "Tempo Traveller": {
    seats: "16+1",
    image: "https://images.pexels.com/photos/14095830/pexels-photo-14095830.jpeg?auto=compress&cs=tinysrgb&w=200",
  },
};

export const vehicleSeats = (name) => VEHICLE_META[name]?.seats || "";
export const vehicleImage = (name) => VEHICLE_META[name]?.image || null;
